import { truncateFloat } from './truncate-float'

const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const getItemPercentMessages = (total, automatica, manual) => {
  const restante = total - automatica - manual

  const percentAutomatica = truncateFloat(automatica / total, 4)
  const percentManual = truncateFloat(manual / total, 4)
  const percentRestante = truncateFloat(restante / total, 4)

  const formattedPercentAutomatica = total ? formatter.format(percentAutomatica) : '-%'
  const formattedPercentManual = total ? formatter.format(percentManual) : '-%'
  const formattedPercentRestante = total ? formatter.format(percentRestante) : '-%'

  return {
    textAutomatica: `${automatica} de ${total} itens conciliados automaticamente (${formattedPercentAutomatica})`,
    textManual: `${manual} de ${total} itens conciliados manualmente (${formattedPercentManual})`,
    textRestante: `${restante} de ${total} itens não conciliados (${formattedPercentRestante})`
  }
}
